<template>
	<el-popover placement="right" trigger="hover" width="370" @show="lazy=true">
		<div>
			<div>
				<el-image :src="imgSizeSet(asinInfo.product_image,370)" v-if="lazy"
					style="width: 100%;height: 370px" ></el-image>
			</div>
			<!--ASIN-标题-->
			<div class="overflow-two-line" style="font-size: 15px;">
				<a :href="'https://www.'+ getCountryObjByCity(country).department +'/dp/' + asinInfo.asin"  target="_blank">
					{{ asinInfo.product_title }}
				</a>
			</div>
			<!--ASIN详细信息-->
			<div style="display: flex" class="middle-div color-text-grey-1">
				<div class="asin-info-item" style="flex: 1">
					<!-- <span class="title">价格：</span> -->
					<span class="emphasis-hint"  v-if=" asinInfo.price">{{ asinInfo.price.raw }}</span>
					<span  v-else class="no-data-font"> -- </span>
				</div>
<!--				<div class="asin-info-item" >-->
<!--					<span class="title">评分：</span>-->
<!--					<span class="value">{{ asinInfo.stars }}</span>-->
<!--				</div>-->
				<div class="asin-info-item">
					<!-- <span class="title">评论数(评分)：</span> -->
						<span v-if="asinInfo.stars">
							<el-rate class="el-start-i-202206210501" v-model="asinInfo.stars" disabled :colors="colors"></el-rate>
							<span class="value">({{ asinInfo.stars }})</span>
						</span>
						<span v-else class="no-data-font"> -- </span>
						<span v-if="asinInfo.ratings">
							{{ toThousands(asinInfo.ratings) }}
						</span>
						<span v-else class="no-data-font"> -- </span>
				</div>
			</div>
			<!--规格-->
			<div class="color-text-grey-1" >
				<div class="overflow-one-line">
					<span v-if="asinInfo.attributes">
						<span v-for="(item,index) in asinInfo.attributes" :key="index">
							{{ item.dimension }} : {{ item.value }}
							<span v-if="index !== asinInfo.attributes.length -1"> | </span>
						</span>
					</span>
				</div>
			</div>
		</div>

		<div slot="reference" style="text-align: center;" @click="clickVariation(asinInfo.asin)">
			<el-image :src="imgSizeSet(asinInfo.product_image)" lazy
				:style="'height:' + height + 'px;width:' + width + 'px'"></el-image>
		</div>
	</el-popover>
</template>

<script>
import { imgSizeSet } from "@/components/common/utils/imgUtils";
import { getCountryObjByCity } from "@/components/config/countryCodeConfig";
import { toThousands } from "@/components/common/utils/fomatNum";

export default {
	name: "asinSimpleSub",
	data() {
		return {
			lazy: false
		}
	},
	props: {
		asinInfo: {
			required: true
		},
		height : {
			default : 40
		},
		width : {
			default: 40
		},
		country : {
			default : 'US'
		}
	},
	created() {},
	methods: {
		clickVariation: function(asin) {
			this.$emit('clickVariation', asin,false)
		},
		imgSizeSet: function(url, size = 80) {
			return imgSizeSet(url, size)
		},
		getCountryObjByCity : function(cite) {
			return getCountryObjByCity(cite)
		},
		toThousands: function(num) {
			return toThousands(num)
		},
	}
}
</script>

<style scoped>

.middle-div{
	border-top: 1px solid #DCDFE6;
	padding: 5px 0;
	margin: 5px 0;
}
.asin-info-item{
	/*text-align: center;*/
}
.asin-info-item .value{
	color: #E6A23C;
}
</style>

<style>
.el-start-i-202206210501 {
	float: left;
	/* margin-right: 5px; */
}

.el-start-i-202206210501 .el-rate__icon {
	margin: 0px;
}

</style>